import type {
  CoreClientChannelsCreatePrivateParams,
  CoreClientChannelsReadParams,
  CoreClientChannelsUpdateParams,
} from '../types/core/methods';
import type {ChannelApiModel} from './types';

import {EntityStore} from '../utils/entityStore';

export class ChannelStore<
  T extends ChannelApiModel = ChannelApiModel,
> extends EntityStore<
  T,
  CoreClientChannelsReadParams,
  CoreClientChannelsCreatePrivateParams,
  CoreClientChannelsUpdateParams
> {}

export const channelStore = new ChannelStore('channel', {
  create: 'client.channels.create_private',
  fetch: 'client.channels.read',
  update: 'client.channels.update',
});
